
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcCircularProgress as ObcCircularProgressElement} from '@oicl/openbridge-webcomponents/dist/building-blocks/circular-progress/circular-progress.js';
 
 
 

 
 export const ObcCircularProgress = createComponent({
   react: React,
   tagName: 'obc-circular-progress',
   elementClass: ObcCircularProgressElement,
   events: {
     
   }
  });
 
 